<template>
  <footer class="footer">
    <div @click="openDialog()" class="footer__item contact-us__link">
      <md-icon md-src="/static/img/contact_us_icon.svg" class="footer__icon"/>
      <span class="footer__text">{{ i18n.lbl_contact_us() }}</span>
    </div>
    <contact-us class="contact-us__popup"
                v-on:close-dialog="closeDialog"
                v-if="showDialog"
                :showDialog="showDialog">
    </contact-us>
  </footer>
</template>

<script>
  import { vueRoutes } from '@router/const'
  import { i18n } from '@js/i18n'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  import ContactUs from './contact-us_popup/contact-us'

  export default {
    name: 'Footer',
    components: { ContactUs },
    data: _ => ({
      showDialog: false,
      vueRoutes,
      i18n
    }),
    computed: {
      ...mapGetters([
        vuexTypes.isLoggedIn
      ])
    },
    methods: {
      openDialog () {
        this.showDialog = true
      },
      closeDialog () {
        this.showDialog = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .footer {
    flex: 0 0 30px;
    color: $default-light-white;
    @include font('main', $font-size-l, 600);

    @include respond-to(medium) {
      @include font('main', $font-size-m, 600);
    }

    &__item {
      cursor: pointer;
    }
    &__icon {
      display: inline-block;
      margin-right: 12px;

      @include respond-to(medium) {
        margin-right: 8px;
      }

      /deep/ path {
        fill: $default-light-white;
        transition: .3s;
      }
    }
    &__text {
      transition: .3s;
    }
    .contact-us__link {
      &:hover {
        .footer__text {
          color: $yellow-push;
        }
        /deep/ .footer__icon path {
          fill: $yellow-push;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/Footer.vue